<app-job-posting-create-interview-dialog
    [openDialog]="openCreateInterviewDialog"
    (createApplicantInterview)="createApplicantInterview($event)"
    (closeApplicantCreateInterviewDialog)="closeApplicantCreateInterviewDialog()"
></app-job-posting-create-interview-dialog>

<app-common-bulk-select-interviewers-dialog #interviewerSelect label="Done" [jobPosting]="jobPosting">
    <p style="text-align: left" class="margin-bottom-4">
        {{ 'applicant-tracker.assignApplicantsTo' | translate: { interviewName: selectedInterview?.name } }}
    </p>
</app-common-bulk-select-interviewers-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-job-posting-header [jobPosting]="jobPosting" (onChangePause)="onPause($event)">
        <div class="buttons">
            <ui-button *ngIf="canCreateInterviews" (click)="showCreateInterviewDialog()" type="primary"
                >{{ 'applicant-tracker.createInterview' | translate }}
            </ui-button>
        </div>
    </app-job-posting-header>

    <ng-container *ngIf="interviews.length && applicantInterviewTables.length">
        <ui-card
            role="group"
            attr.aria-labelledby="interview-{{ index }}-header"
            *ngFor="let interview of interviews; let index = index"
        >
            <div class="interview-card-header">
                <h2 id="interview-{{ index }}-header">{{ interview.name }}</h2>
                <ui-button class="details-link" type="link" (click)="goToInterviewDetails(interview)">{{
                    'applicant-tracker.details' | translate
                }}</ui-button>

                <ui-button
                    (click)="onInterviewAssign(interview)"
                    class="assign-interview"
                    [disabled]="!interviews.length"
                    type="outline"
                >
                    {{ 'applicant-tracker.assignInterview' | translate }}
                </ui-button>
            </div>
            <app-table
                class="applicant-interviews-table"
                [table]="applicantInterviewTables[index]"
                [useStickyHeader]="false"
                [showSearch]="false"
                [showOffset]="false"
                [showActionsPadding]="false"
                [noWhiteSpace]="true"
                [embedded]="true"
            >
                <div class="empty">
                    <div class="ui centered padding-4 empty-applicant-interviews-table">
                        {{
                            'applicant-tracker.messages.interview.assignThisInterviewToAnApplicantAndBeginCollectingFeedback'
                                | translate
                        }}
                    </div>
                </div>
            </app-table>
        </ui-card>
    </ng-container>

    <ng-container *ngIf="!interviews.length">
        <app-empty-state
            src="/assets/illustrations/documents.png"
            label="{{ 'applicant-tracker.messages.interview.viewAndManageAssignedInterviewsFromHere' | translate }}"
        ></app-empty-state>
    </ng-container>
</div>
